module.exports = "/_next/static/images/9bea27de84fcb7406487141d8d95031b-qed.png";